import { useContext } from "react";
import { UserContext } from "../context/provider";
import FullData from "./boxes/fullData";
import SellData from "./boxes/sellData";
import Shops from "./boxes/shops";
import WarehouseHandling from "./boxes/warehouseHandling";
import SellLong from "./boxes/sellLong";
import ProductionCount from "./boxes/productionCount";
import CompareCustomer from "./boxes/compareCustomer";
import SpecialSellData from "./boxes/specialSellData";
import DistributionList from "./boxes/distributionList";
import CustomerSupport from "./boxes/customerSupport";
import DiscountBuilder from "./boxes/discount.tsx";
const BoxHandler = () => {
  const { position } = useContext(UserContext);

  switch (position) {
    case "مقایسه مشتری ها":
      return <CompareCustomer />;
    case "فروشگاه ها":
      return <Shops />;
    case "آمار فروش":
      return <SellData />;
    case "اعمال تخفیف":
      return <DiscountBuilder />;
    case "انبار گردانی":
      return <WarehouseHandling />;
    case "اطلاعات کامل":
      return <FullData />;
    case "طول فروش":
      return <SellLong />;
    case "آمار تولید":
      return <ProductionCount />;
    case "آمار پیشرفته فروش":
      return <SpecialSellData />;
    case "آمار پخش":
      return <DistributionList />;
    case "تماس پشتیبانی مشتریان":
      return <CustomerSupport />;
  }
  //   if(position === "فروشگاه ها"){

  //   }else if(position === "آمار فروش"){
  //       return(
  //           <SellData />
  //       )
  //   }else if(position === "انبار گردانی"){

  //   }else if(position === "اطلاعات کامل"){

  //   }else{
  //       return ""
  //   }
};

export default BoxHandler;
